import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { inject, Injectable } from '@angular/core';
import { Dtos } from '#models';
import { environment } from '#environments';

@Injectable({
  providedIn: 'root',
})
export class OrganizationService {
  private http = inject(HttpClient);

  // public getUserAdminOrgs(businessUnitId: number): Observable<Dtos.Organization[]> {
  //   return this.http.get<Dtos.Organization[]>(
  //     `${environment.apiUrl}/organization/currentUserAdminOrgs/${businessUnitId}`
  //   );
  // }

  // public getOrgList(businessUnitId: number): Observable<Dtos.IdName[]> {
  //   return this.http.get<Dtos.IdName[]>(`${environment.apiUrl}/organization/by-bu/${businessUnitId}`);
  // }

  public getListByBU(businessUnitId: number): Observable<Dtos.Organization[]> {
    return this.http.get<Dtos.Organization[]>(`${environment.apiUrl}/organization/by-current-user/${businessUnitId}`);
  }

  public getOrganization(orgId: number): Observable<Dtos.Organization> {
    return this.http.get<Dtos.Organization>(`${environment.apiUrl}/organization/${orgId}`);
  }

  public addOrganization(businessUnitId: number, organizationName: string): Observable<Dtos.Organization> {
    const bodyData = {
      Name: organizationName,
      BusinessUnitId: businessUnitId,
    };
    return this.http.post<Dtos.Organization>(`${environment.apiUrl}/organization`, bodyData);
  }

  public updateOrganization(organization: Dtos.Organization): Observable<Dtos.Organization> {
    return this.http.put<Dtos.Organization>(`${environment.apiUrl}/organization`, organization);
  }

  public deleteOrganization(id: number): Observable<void> {
    return this.http.put<void>(`${environment.apiUrl}/organization/delete/${id}`, null);
  }

  public addOrganizationUser(orgUsr: Dtos.OrganizationUser): Observable<Dtos.OrganizationUser> {
    return this.http.post<Dtos.OrganizationUser>(`${environment.apiUrl}/organization/addOrganizationUser`, orgUsr);
  }

  public removeOrganizationUser(id: number, email: string): Observable<Dtos.OrganizationUser> {
    return this.http.put<Dtos.OrganizationUser>(`${environment.apiUrl}/organization/removeOrganizationUser/${id}`, {
      Email: email,
    });
  }

  public updateOrganizationUser(orgUsr: Dtos.OrganizationUser): Observable<Dtos.OrganizationUser> {
    return this.http.put<Dtos.OrganizationUser>(`${environment.apiUrl}/organization/updateOrganizationUser`, orgUsr);
  }

  public approveOrganizationUser(organizationId: number, email: string): Observable<Dtos.OrganizationUser> {
    return this.http.put<Dtos.OrganizationUser>(`${environment.apiUrl}/organization/${organizationId}/approve-user`, {
      Email: email,
    });
  }

  // public getOrganizationUser(orgId: number, userId: number): Observable<Dtos.OrganizationUser> {
  //   return this.http.get<Dtos.OrganizationUser>(
  //     `${environment.apiUrl}/organization/getOrganizationUser/${orgId}/${userId}`
  //   );
  // }

  // public getOrgUsersByOrgId(orgId: number): Observable<Dtos.OrganizationUser[]> {
  //   return this.http.get<Dtos.OrganizationUser[]>(`${environment.apiUrl}/organization/getOrgUsersByOrgId/${orgId}`);
  // }

  // public searchOrgUsers(orgId: number, search: string): Observable<Dtos.OrganizationUser[]> {
  //   return this.http.get<Dtos.OrganizationUser[]>(`${environment.apiUrl}/organization/users/${orgId}`, {
  //     params: {
  //       search,
  //     },
  //   });
  // }

  public searchPaginatedOrgUsers(
    orgId: number,
    {
      search = '',

      filterPendingApprovedUsers = false,
    },
    pagination: Dtos.PaginationRequest
  ): Observable<Dtos.PagedList<Dtos.OrganizationUser>> {
    const requestParams = {
      Filter: {
        Search: search,
        FilterPendingApprovedUsers: filterPendingApprovedUsers,
      },
      Pagination: pagination,
    };

    return this.http.post<Dtos.PagedList<Dtos.OrganizationUser>>(
      `${environment.apiUrl}/organization/${orgId}/users`,
      requestParams
    );
  }
}
